export const isLong = (obj: any): obj is Long =>
  obj.low !== undefined && obj.high !== undefined;
